const GameState = {
  gameSetup: 'gameSetup',
  placingShips: 'placingShips',
  shotPrimed: 'shotPrimed',
  shotReceived: 'shotReceived',
  gameOver: 'gameOver',
};

export default GameState;
